// whether the device is mobile or not
export function isMobile() {
  const regex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  const flag = regex.test(navigator.userAgent) || window.screen.width <= 720;
  return flag;
}
